export default __webpack_public_path__ + "static/fa-brands-400-22d47879e2fae7512e070d523b7bb374.svg";